// account/UserMenu.js
import React, { useEffect } from 'react';
import { useAuth } from './AuthContext';

// SVG ikonka ludzika
const UserIcon = () => (
    <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    style={{ marginRight: '6px', verticalAlign: 'middle' }}
    >
    <circle cx="8" cy="5" r="3" />
    <path d="M2 14s1-4 6-4 6 4 6 4H2z" />
    </svg>
);

const UserMenu = () => {
    const { isAuthenticated, userEmail, logout, loading, checkAuthStatus } = useAuth();

    //useEffect - nasłuchuj eventu logowania
    useEffect(() => {
        const handleUserLoggedIn = () => {
            // Odśwież stan autoryzacji po otrzymaniu eventu
            checkAuthStatus();
        };

        // Nasłuchuj custom eventu
        window.addEventListener('userLoggedIn', handleUserLoggedIn);

        // Cleanup
        return () => {
            window.removeEventListener('userLoggedIn', handleUserLoggedIn);
        };
    }, [checkAuthStatus]);

    const handleAccountClick = (e) => {
        e.preventDefault();
        window.location.href = '/account';
    };

    const handleLoginClick = (e) => {
        e.preventDefault();
        window.location.href = '/login';
    };

    // Podczas ładowania
    if (loading) {
        return <div style={{ padding: '8px 16px', color: '#666' }}>...</div>;
    }

    // Jeśli zalogowany - tylko nickname z ikonką
    if (isAuthenticated) {
        const displayName = userEmail ? userEmail.split('@')[0] : 'Użytkownik';

        return (
            <a
            href="/account"
            onClick={handleAccountClick}
            style={{
                textDecoration: 'none',
                color: 'inherit',
                padding: '8px 16px',
                cursor: 'pointer',
                display: 'inline-flex',
                alignItems: 'center'
            }}
            >
            <UserIcon />
            {displayName}
            </a>
        );
    }

    // Jeśli niezalogowany - "Login" z ikonką
    return (
        <a
        href="/login"
        onClick={handleLoginClick}
        style={{
            textDecoration: 'none',
            color: 'inherit',
            padding: '8px 16px',
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center'
        }}
        >
        <UserIcon />
        Login
        </a>
    );
};

export default UserMenu;
